export default "__VITE_ASSET__Cg$JUrkB__"